// 设备管理
export default [
  {
    path: "/device",
    meta: { title: "设备管理" },
    component: () => import("../views/device/index.vue"),
    children: [
      {
        path: "/device/list",
        name: "deviceList",
        meta: { title: "设备列表", isMenu: true },
        component: () => import("../views/device/list.vue"),
      },
    ],
  },
]
